import * as Yup from "yup";

export const dumentVerificationSchema = Yup.object().shape({
    image: Yup.string().required("Please Upload Your government issued ID"),
    user_document_type: Yup.number().min(1,"Select valid option").required("Document type is required"),
    selfie_image: Yup.string().required("Please upload selfie with your ID and handwritten note"),

});